exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".buddyCell-723e4{display:flex;flex-direction:column}.summaryEmployeesTable-f6dde table>tbody>tr>td{padding:0}.summaryEmployeesTable-f6dde table>tbody>tr>td a{padding:16px;display:block;color:#000}.container-2d048{padding:24px;border-radius:12px;background-color:#fff;box-shadow:0 4px 20px 0 rgba(112,112,128,.1)}", ""]);

// Exports
exports.locals = {
	"buddyCell": "buddyCell-723e4",
	"summaryEmployeesTable": "summaryEmployeesTable-f6dde",
	"container": "container-2d048"
};